<template lang="html">
    <div>
        <v-layout align-center justify-end row fill-height>
          <v-btn large color="success" @click="clickCreate()">Criar Página</v-btn>
        </v-layout>

        <!-- List Row -->
        <v-layout row class="mt-3">

          <v-flex v-if="isLoadingPages" xs12 class="text-xs-center fs-larger">
            A carregar páginas
          </v-flex>

          <v-flex v-else-if="!pages || pages.length < 1" xs12 class="text-xs-center fs-larger">
            Sem páginas
          </v-flex>

          <v-flex v-else xs12>

            <v-card>
              <v-list two-line>

                <template v-for="(page, index) in pages" :keys="index">
                  <!-- <v-subheader
                    v-if="item.header"
                    :key="item.header"
                  >
                    {{ item.header }}
                  </v-subheader> -->

                  <!-- <v-divider
                    v-else-if="item.divider"
                    :key="index"
                    :inset="item.inset"
                  ></v-divider> -->

                  <v-list-tile
                    :key="page.id"
                    avatar
                  >

                    <v-list-tile-content>

                      <v-layout w-100 align-center>
                        <!-- Left -->
                        <v-flex grow @click="openPage(page, 'pt')" class="pointer">
                          <v-list-tile-title v-html="page.title"></v-list-tile-title>
                          <v-list-tile-sub-title v-html="getPageUrl(page)"></v-list-tile-sub-title>
                        </v-flex>

                        <!-- Right -->
                        <v-flex shrink>
                          <v-icon @click="copySlugToClipboard(page)">content_copy</v-icon>
                          <v-icon @click="viewPageNewTab(page)">open_in_new</v-icon>
                        </v-flex>
                      </v-layout>

                    </v-list-tile-content>
                  </v-list-tile>

                </template>
              </v-list>
            </v-card>

          </v-flex>
        </v-layout>

    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  created: function () {
    this.getPages();
  },
  data: function () {
    return {
      isLoadingPages: false
    }
  },
  methods:{
    ...mapActions([
      'downloadPages'
    ]),
    getPages: function () {
      this.isLoadingPages = true
      this.downloadPages().then(()=>{
        this.isLoadingPages = false
      })
    },
    clickCreate: function () {
      this.$router.push({name:'PageCreate'})
    },
    openPage: function (page, lang) {
      this.$router.push({ name: 'PageView', params: { pageId: page.id, language: lang } })
    },
    getPageUrl: function (page) {
      return page.urlSlug? process.env.VUE_APP_FE_URL + page.urlSlug : '';
    },
    copySlugToClipboard: function (page) {
      navigator.clipboard.writeText(this.getPageUrl(page)).then(function() {
        /* clipboard successfully set */
      }, function() {
        /* clipboard write failed */
      });
    },
    viewPageNewTab: function (page) {
      window.open(this.getPageUrl(page), '_blank').focus();
    }
  },
  computed: {
    ...mapGetters([
      'getDownloadedPages'
    ]),
    pages: function () {
      return this.getDownloadedPages
    }
  },
}
</script>

<style lang="css" scoped>
</style>
